export default `
mutation updateQuoteRemarks($quoteId: String!, $remarks: String!) {
    updateQuoteRemarks(quoteId: $quoteId, remarks: $remarks)
}
`;
